module.exports = __webpack_public_path__ + "static/img/XJJC.36f4bdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/XJJC.png
// module id = Qdjy
// module chunks = 34